module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"locationHeader":"Standort","noLocation":"Standortdaten fehlen","noAddressDefined":"Standort nicht gefunden","egid":"EGID"}}')
  delete Component.options._Ctor
}
